import { IFormReadonlyModelAccessor } from "../../IFormModelAccessor";

import { IFetchFunctionModelAccessor } from "./FetchFunctionCallContext";

export class FetchFunctionModelAccessor implements IFetchFunctionModelAccessor {
    private readonly model: IFormReadonlyModelAccessor;

    public constructor(model: IFormReadonlyModelAccessor) {
        this.model = model;
    }

    public getCached(path: string, name: "children"): undefined | string[];
    public getCached(path: string, name: "value"): undefined | string;
    public getCached(path: string, name: "children" | "value"): undefined | string | string[] {
        if (name === "children") {
            return this.model.getChildren(path);
        }
        if (name === "value") {
            return this.model.getValue(path);
        }
        throw new Error("Invalid field name: 'value' or 'children' only allowed in 2nd getCached parameter");
    }
}
